import { render, staticRenderFns } from "./BulkUpdateDialog.vue?vue&type=template&id=06accf26&scoped=true"
import script from "./BulkUpdateDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkUpdateDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BulkUpdateDialog.vue?vue&type=style&index=0&id=06accf26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06accf26",
  null
  
)

export default component.exports